import React from 'react';
import { string, object } from 'prop-types';
import classNames from 'classnames';
import NamedLink from '../NamedLink/NamedLink';
import css from './BlogListing.module.css';
import { formatBlogPrismicData } from '../../util/data';

const options = { year: 'numeric', month: 'long', day: 'numeric' };

const BlogListing = props => {
  const { rootClassName, className, blog } = props;
  const classes = classNames(rootClassName || css.root, className);
  const { slug, postDate, title, image, alt } = formatBlogPrismicData(blog);

  return (
    <div className={classes}>
      <NamedLink name="SingleBlogPage" params={{ slug }} className={css.square}>
        <img src={image} loading="lazy" alt={alt} />
      </NamedLink>
      <NamedLink name="SingleBlogPage" params={{ slug }} className={css.title}>
        {title}
      </NamedLink>
      <div className={css.postDate}>
        {postDate && postDate.toLocaleDateString('en-US', options)}
      </div>
    </div>
  );
};

BlogListing.propTypes = {
  rootClassName: string,
  className: string,
  image: string,
  title: string,
  postDate: object,
  slug: string,
  alt: string,
};

BlogListing.defaultProps = {
  rootClassName: null,
  className: null,
  image: null,
  title: null,
  postDate: null,
  slug: null,
  alt: null,
};

export default BlogListing;
